module.exports = __webpack_public_path__ + "static/media/AmEx.5b096aa2.svg";